export default {
  confirm: 'Confirmar',
  title: 'Ofertas elegíveis',
};
